import React from 'react';
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Divider,
  Chip,
  Stack,
} from '@mui/material';

const features = [
  {
    title: 'District Hubs',
    description:
      'Connect with fellow constituents in your district, share insights, and stay informed on local legislative activity.',
    chip: 'Community',
  },
  {
    title: 'Reputation + Contribution Scores',
    description:
      'Earn points for engaging in discussions, summarizing bills, or identifying misinformation — creating a transparent civic leaderboard.',
    chip: 'Gamification',
  },
  {
    title: 'Live Bill Tracking',
    description:
      'Follow legislation from introduction to passage. Get alerts as bills evolve and see who’s backing them in real-time.',
    chip: 'Legislation',
  },
  {
    title: 'Ask Themis',
    description: 'Get real-time help from our AI civic assistant. Ask questions about bills, representatives, or how government works — Themis is here to guide you.',
    chip: 'Support',
  },
  {
    title: 'Mobile App',
    description: 'Access everything on the go—from legislative alerts to AI-powered civic support. Stay informed, take action, and connect with your district from anywhere.',
    chip: 'Civic Power In Your Pocket',
  },
  {
    title: 'State Level Legislation',
    description: 'Track and engage with state-level legislation. Understand how local laws impact your community and connect with state representatives.',
    chip: 'State Legislation',
  },
];

const UpcomingFeatures = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography
        variant="h3"
        align="center"
        fontWeight={700}
        gutterBottom
      >
        Upcoming Features
      </Typography>

      <Typography
        variant="h6"
        align="center"
        color="text.secondary"
        maxWidth="md"
        mx="auto"
        mb={5}
      >
        We’re building the next-generation civic engagement platform. Here’s a look at what we’re launching soon.
      </Typography>

      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={4} useFlexGap flexWrap="wrap">
        {features.map((feature, index) => (
          <Box key={index} sx={{ flex: '1 1 45%', minWidth: 275 }}>
            <Card sx={{ height: '100%', borderRadius: 4, boxShadow: 2 }}>
              <CardContent>
                <Chip
                  label={feature.chip}
                  sx={{ mb: 1, bgcolor: '#f3f3f3', fontWeight: 'bold' }}
                />
                <Typography variant="h5" fontWeight={600} gutterBottom>
                  {feature.title}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          </Box>
        ))}
      </Stack>

      <Divider sx={{ mt: 6, mb: 3 }} />

      <Typography variant="body2" align="center" color="text.secondary">
        Want to support our work or have feedback? Get in touch at support@civixthread.com
      </Typography>
    </Container>
  );
};

export default UpcomingFeatures;
